import { ImportantMessageSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/important-message-svg/important-message-svg.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router , RouterModule } from '@angular/router';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, ImportantMessageSvgComponent],
  selector: 'app-delete-paymet-inst-error',
  templateUrl: './delete-paymet-inst-error.component.html',
  styleUrls: ['./delete-paymet-inst-error.component.scss'],
})
export class DeletePaymetInstErrorComponent implements OnInit {
  accountNumber: any;
  policyId: any;
  constructor(public router: Router, private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    this.accountNumber = history.state.bankAccount;
    this.policyId = history.state.policyId;
  }
}
